module.exports = __webpack_public_path__ + "static/media/Pause.db7f199b.svg";